import { IReward } from './IReward';
import { Reward } from './Reward';

export class WaiveServiceFeeReward extends Reward {
	public static readonly CLASS: string = 'com.bancvue.rcx.config.product.rewards.api.WaiveServiceFeeReward';

	public static readonly NAME: string = 'Waive Service Fee';

	feeWaiveCycles: number = 0;

	constructor(reward?: IReward) {
	  super(WaiveServiceFeeReward.CLASS, reward ? reward.id : null);

	  if (reward) {
	    this.feeWaiveCycles = (reward as any).feeWaiveCycles;
	  }
	}

	getDescription(): string {
	  return `Fee waive: ${this.feeWaiveCycles} cycles`;
	}

	clone(): IReward {
	  const clone = new WaiveServiceFeeReward();
	  Object.assign(clone, this);
	  return clone;
	}
}

export default WaiveServiceFeeReward;
